import React from "react";
import { Row, Col } from "react-bootstrap";
import Logo4BPM from "../../../components/Logo4BPM";

export default function HomeHeader() {
  return (
    <>
      <Row className="text-center mt-4">
        <Col>
          <Logo4BPM />
        </Col>
      </Row>

      <Row className="text-center mt-3">
        <Col>
          <h2>Boletim Online do 4ºBPM BALSAS/MA</h2>
          <p><i>Versão: 28-10-2026</i></p>
        </Col>
      </Row>
    </>
  );
}
